import React, { Component } from "react";
import { Button, Card, Col, Row, Divider, message } from "antd";
import DefaultLayout from "../../../../layouts/DefaultLayout";
import { inject, observer } from "mobx-react";
import quoteStatuses from "../../../../../configs/quote-statuses";
import moment from "moment";

@inject("context")
@observer
class CustomerPortal extends Component {
	componentDidMount() {
		this.validateAccess();
	}

	render() {
		const { customerPortalService } = this.props.context;
		const { customerQuotes, customerName } = customerPortalService;

		return (
			<DefaultLayout
				layoutContentProps={{
					style: {
						maxWidth: "100%",
						paddingLeft: 20,
						paddingRight: 20,
					},
				}}
			>
				<Row>
					<Col xs={24} className="portal-card">
						<Card title={<h1>Welcome {customerName}</h1>} text={<p>Here is some text</p>}>
							{this.renderQuotes(customerQuotes)}
							<Row>
								<Col
									xs={24}
									style={{
										paddingBottom: "15px",
									}}
								>
									<div className="message-portal">
										<p>
											{`Login session ends ${moment(
												customerPortalService.customerTokenExpiresOn
											).fromNow()}`}
										</p>
									</div>
								</Col>
							</Row>
							<Row>
								<Col
									xs={24}
									style={{
										paddingBottom: "15px",
										textAlign: "center",
									}}
								>
									<Button
										type="primary"
										size="small"
										style={{
											background: "#C4C4C4",
											borderColor: "#C4C4C4",
											padding: "0 25px",
										}}
										onClick={this.handleLogoutButtonClick}
									>
										Logout
									</Button>
								</Col>
							</Row>
						</Card>
					</Col>
				</Row>
			</DefaultLayout>
		);
	}

	handleLogoutButtonClick = () => {
		const { customerPortalService } = this.props.context;
		customerPortalService.logout();
		message.success("Successfully logged out", 5);
		this.props.history.push("/customer-login");
	};

	validateAccess = async () => {
		const { token } = this.props.match.params;
		const { customerPortalService } = this.props.context;

		await customerPortalService.validateAccess(token);
		if (customerPortalService.customerAuthorized)
			await customerPortalService.loadQuotes();
		else {
			message.error(
				"Not authorized to access customer portal, please login",
				10
			);
			this.props.history.push("/customer-login");
		}
	};

	renderQuotes(quotes) {
		if (quotes.length === 0) return <h1>No policies registered</h1>;

		return quotes.map(
			function (quote) {
				return [
					<div key={quote.id}>
						<Row>
							<Col
								xs={8}
								style={{
									paddingBottom: "15px",
								}}
							>
								<p>Policy Number</p>
							</Col>
							<Col
								xs={2}
								style={{
									paddingBottom: "15px",
								}}
							>
							</Col>
							<Col
								xs={14}
								style={{
									paddingBottom: "15px",
								}}
							>
								<p>{quote.policyNumber}</p>
							</Col>
						</Row>
						<Row>
							<Col
								xs={8}
								style={{
									paddingBottom: "15px",
								}}
							>
								<p>Product</p>
							</Col>
							<Col
								xs={2}
								style={{
									paddingBottom: "15px",
								}}
							>
							</Col>
							<Col
								xs={14}
								style={{
									paddingBottom: "15px",
								}}
							>
								<p>{quote.product.name}</p>
							</Col>
						</Row>
						<Row>
							<Col
								xs={8}
								style={{
									paddingBottom: "15px",
								}}
							>
								<p>Insurer</p>
							</Col>
							<Col
								xs={2}
								style={{
									paddingBottom: "15px",
								}}
							>
							</Col>
							<Col
								xs={14}
								style={{
									paddingBottom: "15px",
								}}
							>
								<p>{quote.product.insurer.name}</p>
							</Col>
						</Row>
						<Row>
							<Col
								xs={8}
								style={{
									paddingBottom: "15px",
								}}
							>
								<Button
									type="default"
									size="medium"
									block="true"
									onClick={() =>
										this.handleUpdateButtonClick(quote.policyNumber)
									}
								>
									Update
								</Button>
							</Col>
							<Col
								xs={2}
								style={{
									paddingBottom: "15px",
								}}
							>
							</Col>
							<Col
								xs={14}
								style={{
									paddingBottom: "15px",
								}}
							>
								<p>Update your organisational details or Policy cover</p>
							</Col>
						</Row>
						<Row>
							<Col
								xs={8}
								style={{
									paddingBottom: "15px",
								}}
							>
								<Button
									type="default"
									size="medium"
									block="true"
									style={{
										background: "#0170FE",
										borderColor: "#0170FE",
									}}									
									disabled={
										quote.status !== quoteStatuses.RENEWALSENT &&
										quote.status !== quoteStatuses.RENEWING
									}
									onClick={() =>
										this.handleRenewButtonClick(quote.policyNumber)
									}
								>
									Renew
								</Button>
							</Col>
							<Col
								xs={2}
								style={{
									paddingBottom: "15px",
								}}
							>
							</Col>
							<Col
								xs={14}
								style={{
									paddingBottom: "15px",
								}}
							>
								<p>
									Renew your Policy and optionally update your details and cover
								</p>
							</Col>
						</Row>
						<Row>
							<Col
								xs={8}
								style={{
									paddingBottom: "15px",
								}}
							>
								<Button
									type="default"
									size="medium"
									block="true"
									style={{
										background: "#FE725C",
										borderColor: "#FE725C",
									}}	
									onClick={() => this.handleCancellationButtonClick(quote)}
								>
									Cancel
								</Button>
							</Col>
							<Col
								xs={2}
								style={{
									paddingBottom: "15px",
								}}
							>
							</Col>
							<Col
								xs={14}
								style={{
									paddingBottom: "15px",
								}}
							>
								<p>Cancel your Policy</p>
							</Col>
						</Row>
						<Row>
							<Col
								xs={8}
								style={{
									paddingBottom: "15px",
								}}
							>
								<Button
									type="default"
									size="medium"
									block="true"
									style={{
										background: "#3FC57F",
										borderColor: "#3FC57F",
									}}
									onClick={() =>
										this.handleDocumentsButtonClick(quote.policyNumber)
									}
								>
									Documents
								</Button>
							</Col>
							<Col
								xs={2}
								style={{
									paddingBottom: "15px",
								}}
							>
							</Col>
							<Col
								xs={14}
								style={{
									paddingBottom: "15px",
								}}
							>
								<p>Get your Policy documents emailed to you</p>
							</Col>
						</Row>
						<Row>
							<Col
								xs={8}
								style={{
									paddingBottom: "15px",
								}}
							>
								<Button
									type="default"
									size="medium"
									block="true"
									style={{
										background: "#FFD75A",
										borderColor: "#FFD75A",
									}}	
									onClick={() => this.handleMakeClaimButtonClick(quote)}
								>
									Claims
								</Button>
							</Col>
							<Col
								xs={2}
								style={{
									paddingBottom: "15px",
								}}
							>
							</Col>
							<Col
								xs={14}
								style={{
									paddingBottom: "15px",
								}}
							>
								<p>Make a Claim</p>
							</Col>
						</Row>
						{this.renderTrackQuoteClaims(quote)}
						<Divider />
					</div>,
				];
			}.bind(this)
		);
	}

	renderTrackQuoteClaims(quote) {
		return quote.claims.map(
			function (claim) {
				return [
					<Row>
						<Col
							xs={8}
							style={{
								paddingBottom: "15px",
							}}
						>
							<Button
								type="default"
								size="medium"
								block="true"
								onClick={() => this.handleTrackClaimButtonClick(quote, claim)}
							>
								Track Claim
							</Button>
						</Col>
						<Col
								xs={2}
								style={{
									paddingBottom: "15px",
								}}
							>
							</Col>
						<Col
							xs={14}
							style={{
								paddingBottom: "15px",
							}}
						>
							<p>Track a Claim made {moment(claim.fnolDate).fromNow()}</p>
						</Col>
					</Row>,
				];
			}.bind(this)
		);
	}

	handleRenewButtonClick = (policyNumber) => {
		if (policyNumber) {
			this.props.context.insuranceRenewalsService.setOverThePhone(false);
			this.props.history.push(`/renew/${policyNumber}`);
		}
	};

	handleUpdateButtonClick = (policyNumber) => {
		if (policyNumber) {
			this.props.context.insuranceMtaService.setOverThePhone(false);
			this.props.history.push(`/mta/${policyNumber}`);
		}
	};

	handleDocumentsButtonClick = async (policyNumber) => {
		if (policyNumber) {
			const { customerPortalService } = this.props.context;
			await customerPortalService.sendDocuments(policyNumber);
	}
	};

	handleCancellationButtonClick(quote) {
		if (quote && quote.policyNumber) {
			this.props.context.policiesService.setCancellationModalRecord(quote);
			this.props.history.push(`/cancellation/${quote.policyNumber}`);
		}
	}

	handleMakeClaimButtonClick(quote) {
		const { token } = this.props.match.params;

		if (quote && quote.policyNumber) {
			this.props.history.push({
				pathname: "/claim",
				quote: quote,
				token: token,
			});
		}
	}

	handleTrackClaimButtonClick(quote, claim) {
		const { token } = this.props.match.params;

		if (quote && quote.policyNumber && claim) {
			this.props.history.push({
				pathname: "/track-claim",
				quote: quote,
				claim: claim,
				token: token,
			});
		}
	}
}

export default CustomerPortal;
